export const INSTANCE_GROUP_PROPERTY_NAME = "isInstanceGroup";
export const INSTANCE_ROLE_PROPERTY_NAME = "isInstanceRole";
export const ROLE_DISPLAYNAME_PROPERTY_NAME = "displayName";
// Stamped on a native product group by the backend (EPTS-6348), holding the id of the instance the
// group was generated for. This is the authoritative marker for "native group of this instance".
export const NATIVE_INSTANCE_ID_PROPERTY_NAME = "nativeInstanceId";
